import React from 'react';
import { connect } from 'react-redux';

import selectEffectiveUserInfo from '../../../selectors/selectEffectiveUserInfo';

import CN from './SalonName.module.scss';

const SalonName = ({ userName, salonName }) => (
  <div data-bem="SalonName" className={CN.container}>
    <div className={CN.userName}> {userName} @&nbsp;</div>
    <div className={CN.salonName}>{salonName}</div>
  </div>
);

const mapStateToProps = (state) => ({
  salonId: state.currentSalon.id,
  salonName: state.currentSalon.name,
  userName: selectEffectiveUserInfo(state).name,
});

export default connect(mapStateToProps)(SalonName);
